import { Box, Stack, Skeleton } from "@mui/material";

const HomeOverviewSkeleton = () => {
  return (
    <Stack direction="row" alignItems="center" justifyContent="center">
      <Stack
        direction="row"
        sx={{
          backgroundColor: "white",
          display: "flex",
          borderRadius: "4px",
          p: "10px 12px",
          minWidth: "636px",
        }}
      >
        <Skeleton
          variant="rounded"
          sx={{
            width: 222,
            height: 160,
            borderRadius: 1,
            backgroundColor: "#EBEBEB",
          }}
        />

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            ml: "12px",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Stack direction="column">
            <Skeleton
              variant="rounded"
              width={200}
              height={25}
              sx={{ backgroundColor: "#EBEBEB", mb: "4px" }}
            />

            <Skeleton
              variant="rounded"
              width={100}
              height={20}
              sx={{ backgroundColor: "#EBEBEB", mb: "4px" }}
            />
            <Stack direction="row">
              <Skeleton
                variant="rounded"
                width={350}
                height={20}
                sx={{ backgroundColor: "#EBEBEB", mb: "4px" }}
              />
            </Stack>

            <Box
              sx={{
                borderBottom: "1px solid #c2c2c2",
                my: "2px",
              }}
            ></Box>
          </Stack>
          <Stack direction="column">
            <Skeleton
              variant="rounded"
              width={200}
              height={20}
              sx={{ backgroundColor: "#EBEBEB", my: "4px" }}
            />
            <Skeleton
              variant="rounded"
              width={230}
              height={20}
              sx={{ backgroundColor: "#EBEBEB", mb: "4px" }}
            />
            <Skeleton
              variant="rounded"
              width={190}
              height={20}
              sx={{ backgroundColor: "#EBEBEB", mb: "4px" }}
            />
          </Stack>
        </Box>
      </Stack>
    </Stack>
  );
};

export default HomeOverviewSkeleton;
